import * as Scrivito from "scrivito";
import blogObjIcon from "assets/images/blog_obj.svg";
import {
  metadataConfiguratorInitialContent,
  metadataConfiguratorPropertiesGroups,
  metadataEditingConfigAttributes,
  metadataValidations,
} from "objs/_metadataEditingConfig";
import {
  defaultPageEditingConfigAttributes,
  defaultPageInitialContent,
  defaultPageProperties,
  defaultPageValidations,
  defaultPropertiesGroups,
} from "objs/_defaultPageEditingConfig";

Scrivito.provideEditingConfig("Wizard", {
  title: "Wizard",
  thumbnail: blogObjIcon,
  attributes: {
    ...metadataEditingConfigAttributes,
    ...defaultPageEditingConfigAttributes,
  },
  properties: defaultPageProperties,
  propertiesGroups: [
    ...defaultPropertiesGroups,
    ...metadataConfiguratorPropertiesGroups,
  ],
  initialContent: {
    ...metadataConfiguratorInitialContent,
    ...defaultPageInitialContent,
    title: "Wizard",
    showConfiguratorNav: true,
    isProdReady: true,
  },
  validations: [...defaultPageValidations, ...metadataValidations],
});
